import { PRODUCT_IMG } from "@/img/productImages";

export default {
  // Navbar
  "nav.brand": "Bitilinks",
  "nav.subtitle": "Navigation RTK",
  "nav.rtkHost": "RTK 主机",
  "nav.scenarios": "应用场景",
  "nav.antennaParts": "天线配件",
  "nav.selectionQuote": "选型报价",
  "nav.getQuote": "获取选型建议",
  "nav.toggleNav": "切换导航",

  // Hero
  "hero.title": "面向无人系统的 RTK 导航定位硬件矩阵",
  "hero.desc":
    "将 RTK 主机、P900/4G/WIFI 数传、四星全频天线、支架与电源线整理为一套可快速采购的选型体系，覆盖飞控、无人车、无人船、无人机与形变监测场景。",
  "hero.viewQuote": "查看报价表",
  "hero.browseProducts": "浏览产品矩阵",

  "hero.stats": [
    { value: "100km", label: "4G 主机标称数传距离可达" },
    { value: "9~28V", label: "主机与电台统一 DC 供电" },
    { value: "UART+USB", label: "主机标准数据接口" },
    { value: "¥10起", label: "从线材到一体式主机完整报价" },
  ],

  "hero.quickSelectors": [
    { tag: "远距离数据链", name: "BitRtk982-P900, 最大 60Km", price: "¥4800" },
    {
      tag: "远程管理与广域部署",
      name: "BitRtk982-EC20, 4G 可达 100Km",
      price: "¥4300",
    },
    {
      tag: "实验调试与短中距链路",
      name: "BitRtk982-WIFI, 距离与功放有关",
      price: "¥3900",
    },
  ],

  "hero.productImageTitle": "RTK-982 系列主机",
  "hero.productImageSubtitle": "RTK GNSS 高精度导航定位",
  "hero.quickSelectLabel": "快速选型",

  // Taxonomy
  "taxonomy.subtitle": "Product Taxonomy",
  "taxonomy.title": "按物料规则组织，一眼找到需要的硬件类别",
  "taxonomy.codeRule": "100X00XXX",
  "taxonomy.codeRuleDesc": "导航定位大类物料编码规则",

  "taxonomy.categories": [
    { code: "01", title: "GNSS 接收机", desc: "RTK 主机与一体式主机" },
    { code: "02", title: "数传电台", desc: "WIFI 功放、4G 电台" },
    { code: "03", title: "天线", desc: "蘑菇头、磁吸、棒状" },
    { code: "04", title: "配件", desc: "固定孔式、磁吸式支架" },
    { code: "05", title: "线材", desc: "XT60 转 VH3.96 电源线" },
    { code: "06", title: "软件", desc: "软件子类" },
  ],

  // Scenarios
  "scenarios.subtitle": "Application Fields",
  "scenarios.title": "围绕飞控与无人平台部署，保留工程选型语境",

  "scenarios.items": [
    {
      title: "无人车 / 无人船",
      desc: "RTK 主机系列提供 UART x1 与 USB x1 数据接口，DC 9~28V 供电，适合接入飞控与移动平台。",
      points: ["P900 最大 60Km", "4G 可达 100Km", "WIFI 方案可配功放"],
    },
    {
      title: "无人机",
      desc: "四星全频磁吸天线与棒状天线适合小型实验无人车、无人机等轻量平台。",
      points: [],
    },
    {
      title: "形变监测",
      desc: "BitRtkOne001 一体式主机与四星全频蘑菇头天线可用于大坝及山体形变监测。",
      points: [],
    },
    {
      title: "远程管理",
      desc: "BitRadio-EC20 给 P900 数传 RTK 主机提供一路远程管理通道。",
      points: [],
    },
  ],

  // Products
  "products.subtitle": "GNSS Receiver",
  "products.title": "RTK 主机系列：按数传链路选择型号",
  "products.desc":
    "主机尺寸、供电、接口高度一致，选型差异主要来自数传通道和数传距离。",
  "products.priceUnit": "/ 台",

  "products.items": [
    {
      id: "100100001",
      tag: "P900",
      name: "BitRtk982-P900",
      desc: "RTK 主机，含 P900 数传，适合飞控、无人车、无人船。",
      specs: [
        { label: "数传距离", value: "最大 60Km" },
        { label: "数据接口", value: "UART x1 / USB x1" },
        { label: "副天线接口", value: "有" },
        { label: "尺寸", value: "80x50x21mm" },
      ],
      price: "¥4800",
      image: PRODUCT_IMG.product005,
    },
    {
      id: "100100002",
      tag: "4G",
      name: "BitRtk982-EC20",
      desc: "RTK 主机，含 4G 数传，适合更大范围远程部署。",
      specs: [
        { label: "数传距离", value: "可达 100Km" },
        { label: "数据接口", value: "UART x1 / USB x1" },
        { label: "副天线接口", value: "有" },
        { label: "尺寸", value: "80x50x21mm" },
      ],
      price: "¥4300",
      image: PRODUCT_IMG.product011,
    },
    {
      id: "100100003",
      tag: "WIFI",
      name: "BitRtk982-WIFI",
      desc: "RTK 主机，含 WIFI 数传，通信距离与功放有关。",
      specs: [
        { label: "数传距离", value: "与功放有关" },
        { label: "数据接口", value: "UART x1 / USB x1" },
        { label: "副天线接口", value: "有" },
        { label: "尺寸", value: "80x50x21mm" },
      ],
      price: "¥3900",
      image: PRODUCT_IMG.product013,
    },
    {
      id: "100100004",
      tag: "在研",
      name: "BitRtkOne001",
      desc: "一体式主机，面向无人车、无人船与形变监测场景。",
      specs: [
        { label: "数传通道", value: "P900, 4G, lora" },
        { label: "数传距离", value: "1~100Km" },
        { label: "副天线接口", value: "无" },
        { label: "尺寸", value: "φ160x70mm" },
      ],
      price: "¥5300",
      image: PRODUCT_IMG.product015,
    },
  ],

  // Accessories
  "accessories.subtitle": "Radio / Antenna / Parts",
  "accessories.title": "外围硬件围绕主机链路与天线安装展开",
  "accessories.desc":
    "电台用于扩展通信距离或远程管理；天线和支架按接口、固定方式、平台尺寸选择；线材覆盖 XT60 到 VH3.96 的电源转接。",

  "accessories.items": [
    {
      name: "BitWifiPa-8W WIFI 功放",
      desc: "用于增加主机 WIFI 通信距离，SMA 内孔天线接口，DC 9~28V 供电。",
      tags: ["65x50x21mm", "¥400"],
      image: PRODUCT_IMG.product016,
    },
    {
      name: "BitRadio-EC20 4G 电台",
      desc: "给 P900 数传 RTK 主机提供一路远程管理通道，1 路 TTL UART 接口。",
      tags: ["80x50x21mm", "¥500"],
      image: PRODUCT_IMG.product011,
    },
    {
      name: "BitAnt-800S 四星全频蘑菇头天线",
      desc: "BNC 接口，适用于无人车、大坝及山体形变监测，支架需另配。",
      tags: ["φ154x70mm", "¥350"],
      image: PRODUCT_IMG.product008,
    },
  ],

  "quoteBox.title": "从场景到 BOM，减少型号来回确认",
  "quoteBox.steps": [
    { num: "01", title: "选择主机：P900 / 4G / WIFI / 一体式" },
    { num: "02", title: "选择安装：蘑菇头、磁吸、棒状天线" },
    { num: "03", title: "补充配件：支架、电源转接线" },
  ],
  "quoteBox.viewFullQuote": "查看完整报价",

  // Compare Table
  "compare.subtitle": "Selection Table",
  "compare.title": "核心报价与参数对照",
  "compare.col.id": "物料编号",
  "compare.col.category": "品类",
  "compare.col.model": "型号",
  "compare.col.params": "关键参数",
  "compare.col.range": "应用范围",
  "compare.col.price": "价格",

  "compare.rows": [
    {
      id: "100100001",
      category: "RTK 主机",
      model: "BitRtk982-P900",
      tags: ["P900", "最大 60Km", "UART x1", "USB x1", "DC 9~28V"],
      range: "飞控、无人车、无人船",
      price: "¥4800",
    },
    {
      id: "100100002",
      category: "RTK 主机",
      model: "BitRtk982-EC20",
      tags: ["4G", "可达 100Km", "UART x1", "USB x1", "DC 9~28V"],
      range: "飞控、无人车、无人船",
      price: "¥4300",
    },
    {
      id: "100100003",
      category: "RTK 主机",
      model: "BitRtk982-WIFI",
      tags: ["WIFI", "距离与功放有关", "UART x1", "USB x1", "DC 9~28V"],
      range: "飞控、无人车、无人船",
      price: "¥3900",
    },
    {
      id: "100100004",
      category: "一体式主机",
      model: "BitRtkOne001",
      tags: ["P900, 4G, lora", "1~100Km", "UART x1", "USB x1", "DC 9~28V", "φ160x70mm"],
      range: "无人车、无人船、形变监测",
      price: "¥5300",
    },
    {
      id: "100200001",
      category: "数传电台",
      model: "BitWifiPa-8W",
      tags: ["增加 WIFI 通信距离", "SMA 内孔", "DC 9~28V"],
      range: "主机 WIFI 通信扩展",
      price: "¥400",
    },
    {
      id: "100200002",
      category: "数传电台",
      model: "BitRadio-EC20",
      tags: ["1 路 TTL", "SMA 内孔", "DC 9~28V"],
      range: "P900 RTK 主机远程管理通道",
      price: "¥500",
    },
    {
      id: "100300001",
      category: "天线",
      model: "BitAnt-800S",
      tags: ["四星全频蘑菇头", "BNC", "支架另配"],
      range: "无人车、大坝及山体形变监测",
      price: "¥350",
    },
    {
      id: "100300002",
      category: "天线",
      model: "BitAnt-502",
      tags: ["四星全频磁吸", "SMA 内针", "φ48x33mm"],
      range: "小型实验性无人车、无人机",
      price: "¥300",
    },
    {
      id: "100300003",
      category: "天线",
      model: "BitAnt-460",
      tags: ["四星全频棒状", "SMA 内孔", "φ28x60mm"],
      range: "无人机",
      price: "¥200",
    },
    {
      id: "100400001",
      category: "配件",
      model: "BitParts-M110SLB",
      tags: ["固定孔式蘑菇头支架", "螺丝固定", "φ154x70mm"],
      range: "蘑菇头天线固定",
      price: "¥150",
    },
    {
      id: "100400002",
      category: "配件",
      model: "BitParts-M100SD",
      tags: ["磁吸式蘑菇头支架", "磁吸固定", "φ48x33mm"],
      range: "蘑菇头天线固定",
      price: "¥100",
    },
    {
      id: "100400003",
      category: "配件",
      model: "BitParts-B150",
      tags: ["磁吸固定式蘑菇头支架", "磁吸和螺丝固定", "φ28x60mm"],
      range: "蘑菇头天线固定",
      price: "¥100",
    },
    {
      id: "100500001",
      category: "线材",
      model: "VH396-XT60-F-P-100",
      tags: ["XT60 母头转 VH3.96", "1 脚正极", "10cm"],
      range: "电源转接",
      price: "¥10",
    },
    {
      id: "100500002",
      category: "线材",
      model: "VH396-XT60-F-N-100",
      tags: ["XT60 母头转 VH3.96", "1 脚正极", "10cm"],
      range: "电源转接",
      price: "¥10",
    },
    {
      id: "100500003",
      category: "线材",
      model: "VH396-XT60-F-P-200",
      tags: ["XT60 母头转 VH3.96", "1 脚正极", "20cm"],
      range: "电源转接",
      price: "¥12",
    },
    {
      id: "100500004",
      category: "线材",
      model: "VH396-XT60-F-N-200",
      tags: ["XT60 母头转 VH3.96", "1 脚正极", "20cm"],
      range: "电源转接",
      price: "¥12",
    },
    {
      id: "100500005",
      category: "线材",
      model: "VH396-XT60-F-P-300",
      tags: ["XT60 母头转 VH3.96", "1 脚正极", "30cm"],
      range: "电源转接",
      price: "¥15",
    },
    {
      id: "100500006",
      category: "线材",
      model: "VH396-XT60-F-N-300",
      tags: ["XT60 母头转 VH3.96", "1 脚正极", "30cm"],
      range: "电源转接",
      price: "¥15",
    },
  ],

  // Footer
  "footer.company": "理工比特林克(苏州)软件信息技术服务有限公司",
  "footer.backToTop": "返回顶部",

  // Language switch
  "lang.zh": "中文",
  "lang.en": "English",
  "lang.switch": "切换语言",
};
